import { combineReducers } from 'redux';
import { encryptPersistReducer } from 'app/libs/encryptPersistReducer';
import estimate from './estimate';
import reapply from './reapply';

const homeservice = combineReducers({
	estimate: encryptPersistReducer(
		{
			key: 'homeservice.estimate',
		},
		estimate,
	),
	reapply: encryptPersistReducer(
		{
			key: 'homeservice.reapply',
		},
		reapply,
	),
});

export default homeservice;
